import Vue from 'vue'
import VueI18n from 'vue-i18n'

import messages from '@/lang'
import { LOCALES } from '@/lang/config'
import { mapSettings } from '@/utils/settings'

const { userLanguage } = mapSettings(['userLanguage'])

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: userLanguage.get() || LOCALES.DE,
  fallbackLocale: LOCALES.DE,
  messages,
})

export const availableLocales = i18n.availableLocales
